export const certificationCardStyles = {
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 200,
    m: 2,
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
    },
    borderRadius: 2,
    overflow: 'hidden',
    position: 'relative'
  },
  
  topBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: 'linear-gradient(90deg, #2196F3 0%, #1976D2 100%)'
  },

  cardHeader: {
    pb: 0,
    '& .MuiCardHeader-content': {
      overflow: 'hidden'
    }
  },

  title: {
    fontWeight: 500,
    color: 'text.primary',
    mb: 0.5
  },

  syllabusLink: {
    p: 2,
    color: 'primary.main',
    fontWeight: 500,
    '&:hover': {
      color: 'primary.dark'
    }
  },

  cardContent: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },

  platform: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    fontWeight: 500
  },

  completionYear: {
    mt: 2,
    pt: 2,
    borderTop: '1px solid',
    borderColor: 'divider'
  },

  completionYearText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },

  verifyLink: {
    display: 'flex',
    gap: 1,
    justifyContent: 'space-between'
  }
};